const changeTypes = {
  0: 'create',
  1: 'modify',
  3: 'remove',
  5: 'remove-all',
} as const;

type TransformMarketDepthChangeDataType = {
  C: keyof typeof changeTypes;
  E: number;
  M: string;
  N: number;
  O: number;
  P: number;
  Q: number;
  T: 1 | 2; // sell:2,buy:1
  Y: string;
};

function transformMarketDepthChange(data: TransformMarketDepthChangeDataType) {
  const {
    C: changeType,
    E: orderEntryDate,
    M: uniqId,
    N: orderSequenceNumber,
    O: orderId,
    P: price,
    Q: volume,
    T: type, // sell:2,buy:1
    Y: isin,
  } = data;

  return {
    changeType: changeTypes[changeType],
    orderEntryDate,
    orderSequenceNumber,
    orderId,
    price,
    volume,
    type,
    isin,
    uniqId,
    count: 0,
    orderDisplayedQuantity: 0,
    uniqueKey: `${orderSequenceNumber}${orderEntryDate}`,
  };
}

export { transformMarketDepthChange };
